import $ from 'jquery'
$(document).ready(textCirclesHover)

function textCirclesHover(){
    $(".text-circles__item").on('mouseenter',function () {
        $(".text-circles__item").removeClass('text-circles__item--active');
    })
}